import axios, { AxiosInstance } from "axios";

let client: AxiosInstance | undefined;

const createClient = () => {
    const client = axios.create({
        baseURL: "/api",
    });

    return client;
};

export const getClient = () => {
    if (!client) {
        client = createClient();
    }

    return client;
};
